export default __webpack_public_path__ + "static/media/avatar1.2e6cd409.png";